import { getTranslationsBasedOnLanguageCode } from '../mock/misc';

function* fetchTranslationsApi(languageCode) {
  return yield getTranslationsBasedOnLanguageCode(languageCode);
}

export {
  fetchTranslationsApi,
};
